export var filterCallBack = {
    filters: {
        formatDate(date){
            if (date){
                // var formattedDate =
                // return new Date(date).toLocaleDateString();
                // console.log(new Date(date).toLocaleDateString())
                var monthNames = [
                  "Jan", "Feb", "Mar",
                  "Apr", "May", "Jun", "Jul",
                  "Aug", "Sept", "Oct",
                  "Nov", "Dec"
                ];

                var day = new Date(date).getDate();
                var monthIndex =  new Date(date).getMonth();
                var year =  new Date(date).getFullYear();

                return day + ' ' + monthNames[monthIndex] + ' ' + year;
            }
        },

        stock_live_price_date_filter(date){
            if(date){
                var date = new Date(date);

                let options = {
                    day: "numeric", hour: "2-digit", minute: "2-digit",
                    month: "short",
                    year: "numeric",
                };

                return `${date.toLocaleTimeString("en-us", options) } IST`;  //hard coded IST not getting IST short name in time zone options
            }
        },

        close_reco_date_filter(date){
            if(date){
                var date = new Date(date);

                let options = {
                    day: "numeric",
                    month: "short",
                    year: "numeric",
                };

                return `${date.toLocaleDateString("en-us", options) }`;  //hard coded IST not getting IST short name in time zone options
            }
        },

        close_reco_time_filter(date){
            if(date){
                var date = new Date(date);

                let options = {
                    hour: "2-digit", minute: "2-digit"
                };

                return `${date.toLocaleTimeString("en-us", options) } IST`;  //hard coded IST not getting IST short name in time zone options
            }
        },
        
        filterTime(date){
            if(date){
                var date = new Date(date);

                let options = {
                    hour: "2-digit", minute: "2-digit"
                };

                return `${date.toLocaleTimeString("en-us", options) } IST`;  //hard coded IST not getting IST short name in time zone options
            }
        }
    }
}
